import React from "react";

function AboutMain() {
  return (
    <section className="about">
      <h1>the little lemon story</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Non ipsa
        voluptatum accusantium cupiditate accusamus similique ad natus mollitia?
        Est dolor impedit dicta vero repudiandae reprehenderit nulla sunt quod
        rerum nam?
      </p>
      <div className="morph-circle about-img"></div>
    </section>
  );
}

export default AboutMain;
